"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boundarySections = exports.definition = exports.form = void 0;
const types_1 = require("../../types");
const team_section_1 = require("./sections/team.section");
const project_section_1 = require("./sections/project.section");
const engineer_section_1 = require("./sections/engineer.section");
const boundary_section_1 = require("./sections/boundary.section");
const boundaryAdditional_section_1 = require("./sections/boundaryAdditional.section");
const boundaryTechnical_section_1 = require("./sections/boundaryTechnical.section");
const manufacturer_section_1 = require("./sections/manufacturer.section");
const machine_directive_1 = require("./directives/machine.directive");
const electrical_directive_1 = require("./directives/electrical.directive");
const pressureEquipment_directive_1 = require("./directives/pressureEquipment.directive");
const image_document_1 = require("./documents/image.document");
const manual_document_1 = require("./documents/manual.document");
exports.form = {
    type: types_1.Certification.ce,
    sections: [manufacturer_section_1.default, engineer_section_1.default, team_section_1.default, project_section_1.default],
    directives: [
        machine_directive_1.default,
        electrical_directive_1.default,
        pressureEquipment_directive_1.default,
    ],
    documents: [image_document_1.default, manual_document_1.default],
};
exports.definition = {
    primarySections: [engineer_section_1.default, manufacturer_section_1.default, project_section_1.default],
    directiveCategories: [
        {
            category: "machine",
            directive: machine_directive_1.default,
        },
    ],
    secondarySections: {
        machine: ["manual", "installationManual"],
    },
    documents: {
        machine: ["conformity", "intallationDeclaration", "riskAssessment"],
    },
};
exports.boundarySections = [
    boundary_section_1.default,
    boundaryTechnical_section_1.default,
    boundaryAdditional_section_1.default,
];
